<template>
  <div class="footer-container__wrapper">
    <InfoBox />
  </div>
</template>

<script>
import InfoBox from 'Components/InfoBox';

export default {
  name: 'FooterContainer',
  components: { InfoBox }
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';

.footer-container__wrapper {
  // margin: 1em 0 2em 0;
  position: absolute;
  bottom: 25px;
  right: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: $phone) and (max-width: $tablet) {
  }

  @media (min-width: $tablet) and (max-width: $desktop) {
    margin: 2em 0 0em 0;

    h1 {
      font-size: 1.4em;
    }
    .attribution {
      font-size: 0.8em;
    }
  }

  @media (min-width: $desktop) {
    margin: 2em 0 0em 0;

    h1 {
      font-size: 1.6em;
    }
    .attribution {
      font-size: 1em;
    }
  }
}
</style>
